/**
 * @file toBoolean
 * @author Yu Zong(liuxuanzy@qq.com)
 */
export function toBoolean(keys) {
  var map = {};
  keys.forEach(function (key) {
    return map[key] = true;
  });
  return function (obj) {
    return map[obj];
  };
}